import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5 18.677v-7.181c0-.474.188-.927.544-1.23l5.378-4.872c.586-.54 1.465-.518 2.051.021l5.462 5.068c.335.301.523.754.523 1.207L19 19"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9.966 11.128c4.14-.124 3.347 4.81 1.692 3.347-1.202-2.542 2.738-3.823 4.43-1.901S11.457 19 11.457 19s-2.783-2.004-3.584-4.091c-.4-.992-.668-3.699 2.092-3.781"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const HomeIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
